import { CpdlcSession } from "./cpdlcSession.js";
import { abnormalCpdlcDialogStates, EramCpdlcDialog } from "./eramCpdlcDialog.js";
export class EramCpdlcSession extends CpdlcSession {
    /* artccId or null for national, see section 6.1.6 in TI 6110.100, sept 2022 edition */
    logicalDataAuthority = null;
    eligibleSectorId = null;
    heldTOCs = [];
    static getOpenDialogs(session) {
        return Object.values(session.dialogMap).filter((d) => !EramCpdlcDialog.dialogIsClosed(d));
    }
    static getOpenTocDialogs(session) {
        return Object.values(session.dialogMap).filter((d) => d.messages[0].eramMsgType === "TOC" &&
            (!EramCpdlcDialog.dialogIsClosed(d) ||
                (abnormalCpdlcDialogStates.includes(d.eramState) && !d.acknowledgedAt)));
    }
    static getSectorPidDialogs(session, sectorId) {
        if (!sectorId) {
            return [];
        }
        return Object.values(session.dialogMap).filter((d) => d.messages[0].type === "DM" && !d.deleted && d.eligiblePosition?.sectorId === sectorId);
    }
    static getUnackAbnormalDialogs(session) {
        return Object.values(session.dialogMap).filter((d) => abnormalCpdlcDialogStates.includes(d.eramState) && !d.acknowledgedAt && !d.deleted);
    }
    static getFieldASuffix(session, sectorId) {
        const openTocDialog = EramCpdlcSession.getOpenTocDialogs(session)?.at(-1);
        const tocMsg = openTocDialog?.messages[0];
        if (session.heldTOCs.length > 0) {
            // TOC HELD abnormal, see TI6110.100 section 7.2.2.4
            if (session.heldTOCs.some((v) => !v.nextSectorFrequency)) {
                return TOC_HELD_ABNORMAL;
            }
            else {
                return session.heldTOCs.length === 1 ? TOC_HELD_SINGLE : TOC_HELD_MULTIPLE;
            }
        }
        else if (openTocDialog &&
            tocMsg &&
            sectorId &&
            tocMsg.nextSectorId !== sectorId &&
            session.eligibleSectorId === sectorId) {
            return abnormalCpdlcDialogStates.includes(openTocDialog.eramState)
                ? TOC_ABNORMAL_TRANSFER
                : TOC_TRANSFERRING;
        }
        return null;
    }
    static getFieldATocPrefix(session, sectorId) {
        const tocDialog = EramCpdlcSession.getOpenTocDialogs(session)?.at(-1);
        if (sectorId && tocDialog && tocDialog.messages[0]?.nextSectorId === sectorId) {
            return TOC_TRANSFERRING;
        }
        return sectorId && session.eligibleSectorId === sectorId ? CDA_ELIG_SYMBOL : CDA_NOT_ELIG_SYMBOL;
    }
    static getDialogStatus(session, dialogId) {
        const dialog = session && dialogId ? session.dialogMap[dialogId] : null;
        if (dialog) {
            const initialMessage = dialog.messages[0];
            if (abnormalCpdlcDialogStates.includes(dialog.eramState) && !dialog.acknowledgedAt) {
                return "ABNORMAL_CLOSURE";
            }
            if (initialMessage.timeout && !(dialog.cancelledAt || initialMessage.status === "CLOSED")) {
                return "TIMEOUT";
            }
            return initialMessage.status === "CLOSED" || dialog.cancelledAt ? null : "UPLINK_IN_PROGRESS";
        }
        return null;
    }
    static getDialogStatusText(session, dialogId) {
        const status = EramCpdlcSession.getDialogStatus(session, dialogId);
        switch (status) {
            case "ABNORMAL_CLOSURE":
                return UPLINK_ABNORMAL;
            case "UPLINK_IN_PROGRESS":
                return UPLINK_IN_PROGRESS;
            case "TIMEOUT":
                return UPLINK_TIMEOUT;
        }
        return null;
    }
}
// cpdlc font symbols
const PID_EMERGENCY = "\u0200";
const PID_OPEN = "\u0201";
const UPLINK_TIMEOUT = "\u0202";
const UPLINK_ABNORMAL = "\u0203";
const UPLINK_IN_PROGRESS = "\u0204";
const TOC_TRANSFERRING = "\u0205";
const TOC_HELD_MULTIPLE = "\u0206";
const TOC_HELD_SINGLE = "\u0207";
const CAA_TIMEOUT = "\u0208";
const TOC_ABNORMAL_TRANSFER = "\u0209";
const TOC_HELD_ABNORMAL = "\u020a";
const CDA_NOT_ELIG_SYMBOL = "\u020b";
const CDA_ELIG_SYMBOL = "\u020c";
const TOC_COMPLETE_SYMBOL = "\u020e";
const NDA_SYMBOL = "\u020f";
const CPDLC_SESSION_TERMINATED = "\u0210";
//# sourceMappingURL=eramCpdlcSession.js.map